/**
 * Builds a regexp to match phone-numbers.
 *
 * ### Example (es module)
 * ```js
 * import phoneRegex from 'phone-regex-ts'
 * console.log(phoneRegex().test('11234567890'))
 * // => true
 * ```
 *
 * ### Example (commonjs)
 * ```js
 * var phoneRegex = require('phone-regex-ts');
 * console.log(phoneRegex().test('11234567890'))
 * // => true
 * ```
 * @param indian [false] - match Indian phone numbers
 * @param exact [false] - perform an exact match
 */
export const buildRegex = ({ indian = false, exact = false } = {}) => {
    const regexBase = '(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?';
    const indianRegexBase = '(?:(?:\\+|0{0,2})91(\\s*[\\ -]\\s*)?|[0]?)?[789]\\d{9}|(\\d[ -]?){10}\\d';
    if (indian) {
        if (exact) {
            return new RegExp('^' + indianRegexBase + '$');
        }
        else {
            return new RegExp('\\s*' + indianRegexBase + '\\s*', 'g');
        }
    }
    else {
        if (exact) {
            return new RegExp('^' + regexBase + '$');
        }
        else {
            return new RegExp('\\s*' + regexBase + '\\s*', 'g');
        }
    }
};
export default buildRegex;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhvbmUtcmVnZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3Bob25lLXJlZ2V4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FrQkc7QUFDSCxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQUcsQ0FBQyxFQUFFLE1BQU0sR0FBRyxLQUFLLEVBQUUsS0FBSyxHQUFHLEtBQUssRUFBRSxHQUFHLEVBQUUsRUFBRSxFQUFFO0lBQ25FLE1BQU0sU0FBUyxHQUNiLCtFQUErRSxDQUFDO0lBQ2xGLE1BQU0sZUFBZSxHQUNuQiwwRUFBMEUsQ0FBQztJQUU3RSxJQUFJLE1BQU0sRUFBRTtRQUNWLElBQUksS0FBSyxFQUFFO1lBQ1QsT0FBTyxJQUFJLE1BQU0sQ0FBQyxHQUFHLEdBQUcsZUFBZSxHQUFHLEdBQUcsQ0FBQyxDQUFDO1NBQ2hEO2FBQU07WUFDTCxPQUFPLElBQUksTUFBTSxDQUFDLE1BQU0sR0FBRyxlQUFlLEdBQUcsTUFBTSxFQUFFLEdBQUcsQ0FBQyxDQUFDO1NBQzNEO0tBQ0Y7U0FBTTtRQUNMLElBQUksS0FBSyxFQUFFO1lBQ1QsT0FBTyxJQUFJLE1BQU0sQ0FBQyxHQUFHLEdBQUcsU0FBUyxHQUFHLEdBQUcsQ0FBQyxDQUFDO1NBQzFDO2FBQU07WUFDTCxPQUFPLElBQUksTUFBTSxDQUFDLE1BQU0sR0FBRyxTQUFTLEdBQUcsTUFBTSxFQUFFLEdBQUcsQ0FBQyxDQUFDO1NBQ3JEO0tBQ0Y7QUFDSCxDQUFDLENBQUM7QUFFRixlQUFlLFVBQVUsQ0FBQyJ9